interface FilterBarProps {
  status: string;
  onStatus: (value: string) => void;
  year: string;
  onYear: (value: string) => void;
  lead: string;
  onLead: (value: string) => void;
  sort: string;
  onSort: (value: string) => void;
  years: string[];
  leads: string[];
  open: boolean;
  onToggle: () => void;
  onReset: () => void;
  resultCount: number;
}

const statusOptions = ["全部", "已完结", "更新中", "即将上线"];
const sortOptions = [
  { value: "updated", label: "按更新时间" },
  { value: "hot", label: "按热门程度" },
];

function Chip({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors cursor-pointer ${
        active
          ? "bg-primary-600 text-background-50"
          : "bg-background-200/70 text-foreground-700 hover:bg-background-300/70"
      }`}
    >
      {label}
    </button>
  );
}

export default function FilterBar({
  status,
  onStatus,
  year,
  onYear,
  lead,
  onLead,
  sort,
  onSort,
  years,
  leads,
  open,
  onToggle,
  onReset,
  resultCount,
}: FilterBarProps) {
  const hasFilter = status !== "全部" || year !== "全部" || lead !== "全部";

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between gap-3 px-4 py-3 md:px-5">
        <div className="flex items-center gap-2 text-sm text-foreground-700">
          <i className="ri-filter-3-line text-base"></i>
          <span>筛选与排序</span>
          <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800">
            共 {resultCount} 部
          </span>
        </div>
        <button
          type="button"
          onClick={onToggle}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-700 md:hidden cursor-pointer"
        >
          {open ? "收起" : "展开"}
          <i className={`${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-base`}></i>
        </button>
      </div>

      <div className={`${open ? "block" : "hidden"} border-t border-background-200 px-4 py-4 md:block md:px-5`}>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-start">
            <span className="flex w-16 shrink-0 items-center gap-1 pt-1 text-xs text-foreground-500">
              <i className="ri-play-circle-line"></i>状态
            </span>
            <div className="flex flex-wrap gap-2">
              {statusOptions.map((option) => (
                <Chip key={option} active={status === option} label={option} onClick={() => onStatus(option)} />
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:items-start">
            <span className="flex w-16 shrink-0 items-center gap-1 pt-1 text-xs text-foreground-500">
              <i className="ri-calendar-line"></i>年份
            </span>
            <div className="flex flex-wrap gap-2">
              {["全部", ...years].map((option) => (
                <Chip key={option} active={year === option} label={option} onClick={() => onYear(option)} />
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:items-start">
            <span className="flex w-16 shrink-0 items-center gap-1 pt-1 text-xs text-foreground-500">
              <i className="ri-user-star-line"></i>主演
            </span>
            <div className="flex flex-wrap gap-2">
              {["全部", ...leads].map((option) => (
                <Chip key={option} active={lead === option} label={option} onClick={() => onLead(option)} />
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3 border-t border-background-200 pt-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-wrap items-center gap-2">
              <span className="flex w-16 shrink-0 items-center gap-1 text-xs text-foreground-500">
                <i className="ri-sort-desc"></i>排序
              </span>
              {sortOptions.map((option) => (
                <Chip
                  key={option.value}
                  active={sort === option.value}
                  label={option.label}
                  onClick={() => onSort(option.value)}
                />
              ))}
            </div>
            {hasFilter && (
              <button
                type="button"
                onClick={onReset}
                className="flex items-center gap-1.5 whitespace-nowrap self-start rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700 sm:self-auto cursor-pointer"
              >
                <i className="ri-refresh-line"></i>
                重置筛选
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}